export default (str: string) => str.replace(/\s{2,}/g, " ");
